<img *ngIf="logoCampeonato()" class="logo-campeonato" [ngClass]="'esquina-'+esquina_logo" alt=""
     [src]="logoCampeonato()" (error)="campeonato=null" />
<div *ngIf="partido || vivo" class="marcador-vivo" [ngClass]="'posicion-'+posicion">
    <div class="franja">
        <div class="equipo equipo-1">
            <img *ngIf="logoEquipo(0)" class="logo" alt="" [src]="logoEquipo(0)" (error)="logoFallido(0)" />
            <span class="nombre">{{nombreEquipo(0)}}</span>
        </div>
        <div class="tanteo" [ngClass]="{'destello':destello[0]}">{{marcador(0) ?? 0}}</div>
        <div class="tanteo" [ngClass]="{'destello':destello[1]}">{{marcador(1) ?? 0}}</div>
        <div class="equipo equipo-2">
            <span class="nombre">{{nombreEquipo(1)}}</span>
            <img *ngIf="logoEquipo(1)" class="logo" alt="" [src]="logoEquipo(1)" (error)="logoFallido(1)" />
        </div>
    </div>
    <div *ngIf="textoPeriodo()" class="periodo">{{textoPeriodo()}}</div>
    <div *ngIf="jugada && mostrar_jugada" class="jugada" [ngClass]="['jugada-'+jugada.tipo, colorTarjeta()?'tarjeta-'+colorTarjeta():'']">
        <div class="jugada-titulo">
            <span *ngIf="colorTarjeta()" class="tarjeta-icono"></span>{{tituloJugada()}}
        </div>
        <div class="jugada-cuerpo">
            <img *ngIf="logoEquipo(jugada.equipo)" class="jugada-logo" alt="" [src]="logoEquipo(jugada.equipo)" />
            <div class="jugada-textos">
                <span class="jugada-protagonista">{{protagonistaJugada()}}</span>
                <span *ngIf="detalleJugada()" class="jugada-detalle">{{detalleJugada()}}</span>
            </div>
        </div>
    </div>
</div>
